module.exports = __webpack_public_path__ + "static/img/searchIcon1.6cbf47fc.svg";